import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { loginData } = useSelector((state) => state.authInfo);
  const isAuthenticated = loginData?.status === 200 || loginData?.status === 201;


  // For survey details, allow access but preserve the path for login redirect
  if (location.pathname.includes('/survey-details/')) {
    if (!isAuthenticated) {
      // Store the current path in localStorage for redirect after login
      localStorage.setItem('redirectAfterLogin', location.pathname);
      return children;
    }
    return children;
  }

  // For other protected routes, redirect to login if not authenticated
  if (!isAuthenticated) {
    // Redirect to login page with the current location in state
    return <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default ProtectedRoute; 